import React from "react";
import { ConfigureGiftsWithPurchase } from "tsi-common-react/src/apps/checkout/ConfigureGiftsWithPurchase/index";

// The configure-gifts app's actual render. Loaded only on the client (via
// ConfigureGiftsApp's React.lazy import) because the checkout dependency tree is
// not SSR-safe. The reactivated renderer + the client entry already wrap the
// document in the Redux Provider, so no Provider is needed here.
// The ErrorBoundary lives in ConfigureGiftsApp (wrapping Suspense) so it also
// catches chunk-load failures of this lazy module.
const ConfigureGiftsAppInner = (): React.JSX.Element => (
    <ConfigureGiftsWithPurchase />
);

export default ConfigureGiftsAppInner;
